<div class="container">
  <div class="header">
    <h1 class="header__title">Выберите способ оплаты</h1>
    <prlw-icon
      name="close-cross"
      class="close-btn"
      (click)="close()"
    ></prlw-icon>
  </div>

  <ng-container *ngIf="userMode === 'pro'; else setProOverlay">
    <div class="content">
      <div class="item" [class.item--active]="isBasicModifier">
        <div class="item__header" (click)="setCurrentModifier('basic')">
          <span class="toggle" [class.toggle--active]="isBasicModifier"></span>
          <span class="item__title">Простая цена</span>
        </div>
      </div>
      <div class="item" [class.item--active]="isPrepaidModifier">
        <div class="item__header" (click)="setCurrentModifier('prepaid')">
          <span
            class="toggle"
            [class.toggle--active]="isPrepaidModifier"
          ></span>
          <span class="item__title">По предоплате</span>
        </div>
        <div class="item__content">
          <input
            class="input input--last"
            placeholder="Маржа, ₽"
            [prlwDynamicInputPlaceholder]="', ₽'"
            [defaultValue]="prepaidMargin"
            [(ngModel)]="prepaidMargin"
            (keypress)="processKeyUp($event)"
            (paste)="processPaste($event)"
            (click)="setCurrentModifier('prepaid')"
          />
        </div>
      </div>
      <div class="item" [class.item--active]="isDeferModifier">
        <div class="item__header" (click)="setCurrentModifier('defer')">
          <span class="toggle" [class.toggle--active]="isDeferModifier"></span>
          <span class="item__title">С отсрочкой платежа</span>
        </div>
        <div class="item__content">
          <input
            class="input"
            placeholder="Введите процент, %"
            [prlwDynamicInputPlaceholder]="'&nbsp;%'"
            [defaultValue]="deferPercent"
            [(ngModel)]="deferPercent"
            (keypress)="processKeyUp($event)"
            (paste)="processPaste($event)"
            (click)="setCurrentModifier('defer')"
          />
          <input
            class="input input--last"
            placeholder="Введите дни отсрочки"
            [prlwDynamicInputPlaceholder]="''"
            [pluralizePlaceholder]="['&nbsp;день', '&nbsp;дня', '&nbsp;дней']"
            [defaultValue]="deferPeriod"
            [(ngModel)]="deferPeriod"
            (keypress)="processKeyUp($event)"
            (paste)="processPaste($event)"
            (click)="setCurrentModifier('defer')"
          />
        </div>
      </div>

      <div class="sort">
        <span class="sort__title">Сортировать по:</span>
        <div
          class="sort__item"
          [class.sort__item--active]="sort === 'ASC'"
          (click)="updateSort('ASC')"
        >
          <span
            class="toggle toggle--sort"
            [class.toggle--active]="sort === 'ASC'"
          ></span>
          <span>По возрастанию</span>
        </div>
        <div
          class="sort__item"
          [class.sort__item--active]="sort === 'DES'"
          (click)="updateSort('DES')"
        >
          <span
            class="toggle toggle--sort"
            [class.toggle--active]="sort === 'DES'"
          ></span>
          <span>По убыванию</span>
        </div>
      </div>
    </div>

    <div class="footer">
      <button class="apply-btn" [disabled]="isApplyDisabled" (click)="apply()">
        Подтвердить
      </button>
    </div>
  </ng-container>

  <ng-template #setProOverlay>
    <prlw-light-mode-overlay
      [isOpenFromModifiers]="true"
      (closeOverlay)="closeModifierOverlay($event)"
    ></prlw-light-mode-overlay>
  </ng-template>
</div>
